import { useContext } from 'react'

import { ChatContext } from '@contexts/chat'

const useChat = () => useContext(ChatContext)

export default {
  useChat,
}
